



















import { Component, Vue } from 'vue-property-decorator';

import Page from '@/componentsV2/molecules/Page/Page.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import TabsNavigation from '@/componentsV2/molecules/TabsNavigation/TabsNavigation.vue';
import GeneralInfo from './Tabs/GeneralInfo.vue';
import HoursOfOperation from './Tabs/HoursOfOperation.vue';
import flagKeys from '@/constants/flagKeys';
import segmentIo from '@/utils/segment.io';
import { IBusinessType } from '@/models/business';

@Component({
  components: {
    Page,
    Typography,
    GeneralInfo,
    HoursOfOperation,
    TabsNavigation
  }
})
export default class BusinessProfileRoot extends Vue {
  activeTabValue = this.tabs[0].value;

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get openingHoursIsActive() {
    return this.flags.includes(flagKeys.openingHours);
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business || {};
  }

  get tabs() {
    const tabs = [
      {
        label: 'General Info',
        value: 'GeneralInfo'
      }
    ];

    if (
      this.openingHoursIsActive &&
      this.businessInfo.type !== IBusinessType.ONLINE
    )
      tabs.push({
        label: 'Operating Hours',
        value: 'HoursOfOperation'
      });
    return tabs;
  }

  changeTab(value: { label: string; value: string }) {
    segmentIo.track('Business Info | Changed Tab', {
      To: value.value,
      From: this.activeTabValue
    });
    this.activeTabValue = value.value;
  }

  created() {
    if (
      this.$route.query.tab &&
      this.tabs.filter(tab => tab.value === this.$route.query.tab)[0]
    ) {
      this.activeTabValue = this.$route.query.tab as string;
    }
  }
}
